// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 10px 28px;
  border: none;
  border-radius: 6px;
  background: var(--gradient-accent);
  color: var(--color-white);
  cursor: pointer;
  margin-right: 1rem;
  text-decoration: none;
  display: inline-block;
  transition: opacity 0.15s;
}

.button:focus { outline: none; }

.button:hover,
.button:active { opacity: 0.85; }

.button--inverse {
  background: transparent;
  color: var(--color-blue);
  border: 1px solid rgba(0, 168, 255, 0.3);
}

.button--inverse:hover,
.button--inverse:active { opacity: 0.85; }

.button--danger { background: var(--gradient-danger); }

.button--danger:hover,
.button--danger:active { opacity: 0.85; }

.button:disabled,
.button:hover:disabled,
.button:active:disabled {
  background: #d0d0d0;
  color: #999;
  border: 1px solid #c0c0c0;
  cursor: not-allowed;
  opacity: 1;
}

.button--small { font-size: 0.8rem; }
.button--big   { font-size: 1.5rem; }
`, "",{"version":3,"sources":["webpack://./src/shared/components/FormElements/Button.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,gBAAgB,aAAa,EAAE;;AAE/B;iBACiB,aAAa,EAAE;;AAEhC;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;0BAC0B,aAAa,EAAE;;AAEzC,kBAAkB,kCAAkC,EAAE;;AAEtD;yBACyB,aAAa,EAAE;;AAExC;;;EAGE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,iBAAiB,iBAAiB,EAAE;AACpC,iBAAiB,iBAAiB,EAAE","sourcesContent":[".button {\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  padding: 10px 28px;\n  border: none;\n  border-radius: 6px;\n  background: var(--gradient-accent);\n  color: var(--color-white);\n  cursor: pointer;\n  margin-right: 1rem;\n  text-decoration: none;\n  display: inline-block;\n  transition: opacity 0.15s;\n}\n\n.button:focus { outline: none; }\n\n.button:hover,\n.button:active { opacity: 0.85; }\n\n.button--inverse {\n  background: transparent;\n  color: var(--color-blue);\n  border: 1px solid rgba(0, 168, 255, 0.3);\n}\n\n.button--inverse:hover,\n.button--inverse:active { opacity: 0.85; }\n\n.button--danger { background: var(--gradient-danger); }\n\n.button--danger:hover,\n.button--danger:active { opacity: 0.85; }\n\n.button:disabled,\n.button:hover:disabled,\n.button:active:disabled {\n  background: #d0d0d0;\n  color: #999;\n  border: 1px solid #c0c0c0;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.button--small { font-size: 0.8rem; }\n.button--big   { font-size: 1.5rem; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
